import styled from '@emotion/styled';
import { fontWeight } from 'src/assets/fonts-config';

export const CheckboxTitle = styled('div', { label: 'CheckboxTitle' })`
    margin-left: 8px;
    font-weight: ${fontWeight.regular};
    font-size: 14px;
`;

export const Note = styled('div', { label: 'Note' })`
    font-size: 12px;
    line-height: 1.14;
`;

export const CsvInfoWrapper = styled('div', { label: 'CsvInfoWrapper' })`
    margin: 16px 0 39px 0;
`;
